import React from "react";
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

const LoginPieChartInf = (props) => {
    const {datos} = props;
    
    const datosFormateados = [
        {
            name: "Presentados",
            value: datos&&datos.infPresentadosPorc,
            informes: datos&&datos.infPresentados
        },
        {
            name: "Por presentar",
            value: datos&&datos.infPorPresentarPorc,
            informes: datos&&datos.infPorPresentar
        }
    ];

    const COLORS = ['#DB2491', '#2CC9D6'];

    const formatPorcentaje = numOriginal => {
        var resultado = "";
        resultado = Number(numOriginal).toFixed(2);
        resultado.toString();
        return resultado;
    };

    const CustomTooltip = ({active, payload, label}) => {
        if (active && payload && payload.length) {
            if(payload[0].name === "Presentados") {
                return (
                    <div className="tooltipGrafica">
                        <b>&nbsp;Informes presentados&nbsp;</b><br/>&nbsp;{payload[0].payload.informes}
                    </div>
                );
            } else {
                return (
                    <div className="tooltipGrafica">
                        <b>&nbsp;Informes por presentar&nbsp;</b><br/>&nbsp;{payload[0].payload.informes}
                    </div>
                );
            }
        }
        return null;
    };

    if(datos) {
        return (
            <div>
                <ResponsiveContainer width="100%" minHeight={330} maxHeight={1040}>
                    <PieChart width={430} height={330}>
                        <Pie data={datosFormateados} dataKey="value" nameKey="name" cx="50%" cy="75%"
                                startAngle={180} endAngle={0} innerRadius={140} outerRadius={160}>
                            {datosFormateados.map((entry, index) =>(
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Legend payload={datosFormateados.map((item, index) => ({
                            id: item.name,
                            type: "circle",
                            value: <>&nbsp;&nbsp;{item.name}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br/>
                                <span className={"legendInf"+index}>{formatPorcentaje(item.value)}%</span></>,
                            color: COLORS[index % COLORS.length]
                        }))} />
                        <Tooltip content={<CustomTooltip />} />
                    </PieChart>
                </ResponsiveContainer>
            </div>
        );
    } else {
        return <div>Cargando...</div>
    }
};

export default LoginPieChartInf;